import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../index";
import type { PoolRoomState } from "@/shared/types";

interface PoolState {
  roomState: PoolRoomState | null;
  error: string | null;
  lastUpdatedAt: number | null;
}

const initialState: PoolState = {
  roomState: null,
  error: null,
  lastUpdatedAt: null
};

const poolSlice = createSlice({
  name: "pool",
  initialState,
  reducers: {
    poolStateReceived: (state, action: PayloadAction<PoolRoomState>) => {
      const incoming = action.payload;
      if (!state.roomState || incoming.version >= state.roomState.version) {
        state.roomState = incoming;
        state.error = null;
        state.lastUpdatedAt = Date.now();
      }
    },
    poolStateHydrated: (state, action: PayloadAction<PoolRoomState>) => {
      state.roomState = action.payload;
      state.error = null;
      state.lastUpdatedAt = Date.now();
    },
    poolCommandRejected: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.lastUpdatedAt = Date.now();
    },
    clearPoolState: () => initialState
  }
});

export const {
  poolStateReceived,
  poolStateHydrated,
  poolCommandRejected,
  clearPoolState
} = poolSlice.actions;

export const selectPoolRoomState = (state: RootState) => state.pool.roomState;
export const selectPoolError = (state: RootState) => state.pool.error;
export const selectPoolLastUpdatedAt = (state: RootState) => state.pool.lastUpdatedAt;

export default poolSlice.reducer;

